import React, { MouseEvent } from 'react';
import { Button } from '@kvdbil/components';
import { useTranslation } from '~/Locale';
import { formatMoney } from '~/helpers/currency';

export interface BiddingButtonProps {
  bidAmount: string;

  isMaxBid: boolean;
  isLoading: boolean;
  isDisabled?: boolean;
  isConfirmation: boolean;

  onPlaceBid(event: MouseEvent<HTMLButtonElement>): void;
  onConfirmBid(event: MouseEvent<HTMLButtonElement>): void;
}
export const BiddingButton = ({
  bidAmount,
  onPlaceBid,
  onConfirmBid,
  isMaxBid,
  isLoading,
  isDisabled,
  isConfirmation
}: BiddingButtonProps) => {
  const { t } = useTranslation();

  if (isConfirmation) {
    return (
      <Button
        color="secondary"
        data-testid="confirm-bid-button"
        fullWidth
        onClick={onConfirmBid}
        isLoading={isLoading}
        isDisabled={isDisabled}
        size="large"
      >
        {isMaxBid
          ? t(
              'Confirm maxbid of %1$s',
              formatMoney({
                value: bidAmount,
                currency: t('SEK')
              })
            )
          : t(
              'Confirm bid of %1$s',
              formatMoney({
                value: bidAmount,
                currency: t('SEK')
              })
            )}
      </Button>
    );
  }

  return (
    <Button
      color="secondary"
      fullWidth
      onClick={onPlaceBid}
      isLoading={isLoading}
      isDisabled={isDisabled}
      size="large"
      type="button"
    >
      {isMaxBid ? t('Place max bid') : t('Place bid')}
    </Button>
  );
};

export default BiddingButton;
